import { render } from "./All_Properties.vue?vue&type=template&id=fdc7c112"
import script from "./All_Properties.vue?vue&type=script&lang=js"
export * from "./All_Properties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__